var checkPaymentAndRedirect = function(checkUrl) {
    $.ajax({
        method: "POST",
        url: checkUrl,
    })
        .done(function(response) {

            var redirect_url = response.redirect_url;

            if (typeof redirect_url !== 'undefined' && redirect_url.length > 0) {
                window.location.replace(response.redirect_url);
            } else {
                console.log('retry');
                setTimeout(checkPaymentAndRedirect, 2000, checkUrl);
            }
        });
};

jQuery(document).ready(function () {
    var paymentValidateEl = $('.dnPaymentValidate');

    if (paymentValidateEl.length) {
        var checkUrl = paymentValidateEl.attr('data-check-url');

        checkPaymentAndRedirect(checkUrl);
    }
});
